import { Action } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { ApplicationState } from "../../../store/ApplicationState";
import { documentDownload, getDocumentList } from "../../../actions/AuthorizationDetailsTab";
import InboundDocumentation from "../components/InboundDocumentation";
import { DocumentListDispatchTypes } from "../../../models/DispatchTypes/AuthorizationDetailstab";
import { DocumentDownloadDispatchTypes } from "../../../constants/Document";


const mapStateToProps = ({
  documentListState,
  documentDownloadState
}: ApplicationState) => ({
  documentListState: documentListState.response,
  documentDownloadData: documentDownloadState
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, (DocumentListDispatchTypes | DocumentDownloadDispatchTypes) & Action >
) => {
    return {
      getDocumentList: (referralId: number,type:number) => {
        dispatch(getDocumentList(referralId,type));
      },
      documentDownload: (blobId: number) => {
        dispatch(documentDownload(blobId));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InboundDocumentation);
